import { axiosInstance } from '.';

const getProfileDetails = async (params) => await axiosInstance.get('/service_providers/me');

const setupProfile = async (payload) => await axiosInstance.patch('/service_providers/update_profile', payload);

export { getProfileDetails, setupProfile };
